<h2 mat-dialog-title>Enter/Select Delimiter</h2>
<app-autocomplete-field-separator 
        [(ngModel)]="delimiter">
    </app-autocomplete-field-separator>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()">OK</button>
</mat-dialog-actions>





